import { useMutation } from '@tanstack/react-query';
import { backendServices } from '../../services';
import { DocumentViewModel } from '../../services/backendServices/ViewModels';

export function usePostDocumentDraft() {
    const mutation = useMutation({
        mutationFn: async (body: DocumentViewModel) => {
            const api = new backendServices.Apis.DocumentApi();
            const res = await api.postDocumentDraft(body);
            return res.data;
        },
    });

    return mutation;
}
